import { brl } from "@/lib/api";

export function ImportGroups({ groups, categories, targets, setTargets }) {
  if (!groups.length) return null;
  return (
    <div className="space-y-2" data-testid="menu-import-groups">
      <p className="eyebrow">Complementos encontrados</p>
      {groups.map((g) => (
        <div key={g.key} className="flex flex-col gap-2 rounded-xl border p-3 sm:flex-row sm:items-center" data-testid={`menu-import-group-${g.key}`}>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold">{g.name}</p>
            <p className="truncate text-xs text-muted-foreground">{g.options.map((o) => `${o.name}${o.price ? ` (+${brl(o.price)})` : ""}`).join(", ")}</p>
          </div>
          <select value={targets[g.key]} onChange={(e) => setTargets((t) => ({ ...t, [g.key]: e.target.value }))}
            className="h-9 rounded-md border bg-transparent px-2 text-sm" data-testid={`menu-import-group-target-${g.key}`}>
            <option value="all">Aplicar em todos os produtos</option>
            {categories.map((c) => <option key={c.key} value={c.key}>Aplicar em: {c.name}</option>)}
            <option value="none">Não importar</option>
          </select>
        </div>
      ))}
    </div>
  );
}
